import Swiper from "swiper";
import {Autoplay, EffectFade, Pagination, EffectCoverflow, Navigation, FreeMode} from "swiper/modules";

// @ts-ignore
global.$ = global.jQuery = require('jquery');

$.fn.shuffle = function () {
    const allElems = this.get(),
        getRandom = function (max) {
            return Math.floor(Math.random() * max);
        },
        shuffled = $.map(allElems, function () {
            const random = getRandom(allElems.length),
                randEl = $(allElems[random]).clone(true)[0];
            allElems.splice(random, 1);
            return randEl;
        });

    this.each(function (i) {
        // @ts-ignore
        $(this).replaceWith($(shuffled[i]));
    });

    return $(shuffled);

};

$(function () {
    $('body').addClass('loaded')
});


// // @ts-ignore
// window.$ = $

// @ts-ignore
// window.jQuery = require('jquery');

//
import "./libs"

//
import "./common/scrollbar-width"
import "./header/header"
import "./front-page/font-page"
import "./singular/project"
import "./common/callback"
import "./common/lightbox"
import "./common/sidebar"


$('.collapsed-grid .show-more').on('click', (event) => {
    event.preventDefault()

    const $btn = $(event.currentTarget)
    const shown = parseInt($btn.attr('data-shown'))
    const step = parseInt($btn.attr('data-step'))
    const showTo = shown + step;

    const $grid = $btn.parents('.collapsed-grid')
    const $items = $grid.find('[data-number].d-none')

    $items
        .filter((i, item) => {
            console.log(item)
            return parseInt($(item).attr('data-number')) <= showTo
        })
        .removeClass('d-none')

    $btn.attr('data-shown', showTo)

    if ($items.length <= step) {
        $btn.closest('.more').addClass('d-none')
    }
});


$('.collapsed-grid .show-all').on('click', (event) => {
    event.preventDefault()

    const $btn = $(event.currentTarget)
    const $grid = $btn.parents('.collapsed-grid')
    const $items = $grid.find('[data-number].d-none')
    $items.removeClass('d-none')

    $btn.closest('.more').addClass('d-none')
});

$('.toggle-player').on('click', (event) => {
    event.preventDefault()

    const $btn = $(event.currentTarget).addClass('active')
    const $players = $btn.parents('.players')

    const currentPlayer = $btn.attr('data-player')

    $players.find('[data-player]:not([data-player="' + currentPlayer + '"])').removeClass('active')

    // $btn.attr('data-current', currentPlayer === 'youtube' ? 'rutube' : 'youtube')
    // $btn.text('Использовать плеер ' + (currentPlayer !== 'youtube' ? 'RuTube' : 'YouTube'))

    const $grid = $btn.parents('.collapsed-grid')

    $grid.find('.player.' + currentPlayer).removeClass('d-none')
    $grid.find('.player:not(.' + currentPlayer + ')').addClass('d-none')
});

// Галерея поста
$(function () {
    const $swiper = $('.post-gallery .swiper')

    if (!$swiper.length) {
        return
    }

    const swiper = new Swiper($swiper.get(0), {
        modules: [Autoplay, Pagination],
        centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: false
        },
        grabCursor: true,
        spaceBetween: 10,
        breakpoints: {
            320: {
                slidesPerView: 1.2,
            },
            768: {
                slidesPerView: 2.2,
            },
        },
        pagination: {
            el: $swiper.find(".swiper-pagination").get(0),
            dynamicBullets: true,
            clickable: true,
        },
        on: {
            init: function () {
                // @ts-ignore
                window.lightbox && window.lightbox?.refresh()
            },
        },
    })
});
// import 'intl-tel-input/build/css/intlTelInput.css';
// import intlTelInput from 'intl-tel-input';
//
// const input = document.querySelector("#phone");
// import { ru } from "intl-tel-input/i18n";
//
// if (input) {
//     intlTelInput(input as HTMLInputElement, {
//         loadUtils: () => import("intl-tel-input/utils"),
//         initialCountry: "ru",
//         i18n: ru,
//         countryNameLocale: "ru"
//
//     });
// }

$('.to-messenger').on('click', (event) => {
    //@ts-ignore
    window.ym && ym(48753395, 'reachGoal', 'to-messenger')
})